/** Stop overt sales and advertisements in shopper conversations. */
export const FLYER_BUILDER_PATH = '/advertise/checkout?mode=builder';
export function isCommercialPost(input: {title?: string | null;content?: string | null;fileNames?: readonly string[]}): boolean {
  const text = [input.title,input.content].filter(Boolean).join(' ').slice(0,10500);
  const filenames = (input.fileNames ?? []).join(' ');
  // Reporting an ad is not posting an ad.
  if (/\b(?:is this|how do i report|why|beware of|someone is|reporting)\b.{0,65}\b(?:flyer|selling|ad|advertis)/i.test(text)) return false;
  return [
    /\b(?:our|my)\s+(?:store|shop|business|grocery|company)\b.{0,100}\b(?:for sale|sell|selling|order|shop|deals?|discount|promo(?:tion)?|flyer|weekly specials?|sale)\b/i,
    /\b(?:shop now|buy now|order now|shop our|visit our store|message us to order|dm (?:me|us) to (?:order|buy)|limited time offer|grand opening sale|wholesale orders)\b/i,
    /\b(?:i am|i'm|we are|we're)\s+selling\b/i,
    /\bfor sale\s*[:!–-]?\s*\w+/i,
    /\b(?:post|upload|share|advertise|promote|publish)\b.{0,50}\b(?:flyer|sales ad|advertisement|weekly specials)\b/i,
  ].some(rule=>rule.test(text)) ||
    /\b(?:store|business|weekly|sales|promotion|grocery)\b.{0,35}\b(?:flyer|poster|price.?list|advertisement)\b/i.test(filenames);
}
